import React from "react";
import { ExternalLink } from "../../../components/ExternalLink";

import SecureScoreProfileConstants from "./secure-score-profile-constants";
import { deserializeCompliance } from "./secure-score-profile-utils";

/** @typedef {import ('./constants').SecureScoreProfileType} SecureScoreProfileType */

const secureScoreProfilePostureConfigs = ({
  AUGMENTT_POSTURE_STATES,
  COMPLIANCE_TYPES,
}) => {
  const secureScoreProfileConstants = new SecureScoreProfileConstants({
    COMPLIANCE_TYPES,
  });

  const { SECURE_SCORE_PROFILE_TYPES } = secureScoreProfileConstants;

  const keys = Object.keys(SECURE_SCORE_PROFILE_TYPES);
  const result = {};

  keys.forEach(
    /* @type {SecureScoreProfileType} */ (key) => {
      const type = SECURE_SCORE_PROFILE_TYPES[key];
      result[type] = {
        rationale: ({ intl }) => {
          const externalLinkId = `SECURE.RATIONALE.EXTERNAL.LINK.${key}`;
          const externalLink = intl?.formatMessage({
            id: externalLinkId,
          });

          const rationaleId = `SECURE.RATIONALE.${key}`;
          const rationale = intl?.formatMessage({
            id: rationaleId,
          });

          return (
            <>
              {rationale !== rationaleId && rationale}
              {externalLink !== externalLinkId && (
                <div>
                  <ExternalLink href={externalLink} label={externalLink} />
                </div>
              )}
            </>
          );
        },
        statusDetailsFormatter: (row, intl) => {
          const positiveId = `SECURE.STATUS_DESCRIPTION.POSITIVE.${key}`;
          const positiveFormattedMessage = intl?.formatMessage({
            id: positiveId,
          });
          const positiveMessage =
            positiveId !== positiveFormattedMessage
              ? positiveFormattedMessage
              : "";

          const negativeId = `SECURE.STATUS_DESCRIPTION.NEGATIVE.${key}`;
          const negativeFormattedMessage = intl?.formatMessage({
            id: negativeId,
          });
          const negativeMessage =
            negativeId !== negativeFormattedMessage
              ? negativeFormattedMessage
              : "";
          return row.status === AUGMENTT_POSTURE_STATES.COMPLIANT
            ? positiveMessage
            : negativeMessage;
        },
        compliance: ({ intl }) => {
          const complianceId = `SECURE.COMPLIANCE.${key}`;
          const complianceFormattedMessage = intl?.formatMessage({
            id: complianceId,
          });
          const compliance =
            complianceId !== complianceFormattedMessage
              ? deserializeCompliance(
                  complianceFormattedMessage,
                  COMPLIANCE_TYPES
                )
              : COMPLIANCE_TYPES.NONE;
          return compliance;
        },
      };
    }
  );

  return Object.freeze(result);
};

export { secureScoreProfilePostureConfigs };
